import { IMonitoringPointResponse } from '@kcftech/prometheustypescriptapiclient';
import {
    Dropdown,
    DropdownItemRenderer,
    DropdownLabelRenderer,
} from 'components/dropdown/Dropdown';
import { useMonitoringPointOverviewInfiniteDataSource } from 'custom_hooks/data_hooks/data_source/monitoringPointDataSource';
import { useEffect } from 'react';
import { getId } from 'utils/data';
import { buildTooltip } from 'utils/group_hierarchy';

const renderLabel: DropdownLabelRenderer<IMonitoringPointResponse> = ({ value }) =>
    value
        ? buildTooltip(value.Hierarchy, undefined, value.Name)
        : 'Select a monitoring point';

const renderItem: DropdownItemRenderer<IMonitoringPointResponse> = ({ item }) =>
    buildTooltip(item.Hierarchy, undefined, item.Name);

export type MonitoringPointDropdownProps = Readonly<{
    corporationId?: string;
    locationId?: string;
    parentId?: string;
    value: IMonitoringPointResponse | undefined;
    onChange: (newValue: IMonitoringPointResponse) => void;
}>;

export function MonitoringPointDropdown({
    corporationId,
    locationId,
    parentId,
    value,
    onChange,
}: MonitoringPointDropdownProps) {
    const {
        results,
        isLoading,
        filter,
        setFilter,
        hasNext,
        loadNext,
    } = useMonitoringPointOverviewInfiniteDataSource({
        name: 'monitoring-point-dropdown',
        pageLimit: 25,
        defaultFilter: {
            corporationId,
            locationId,
            parentId,
        },
    });

    useEffect(
        () =>
            setFilter((current) => ({ ...current, parentId, locationId, corporationId })),
        [corporationId, locationId, parentId, setFilter]
    );

    return (
        <Dropdown<IMonitoringPointResponse>
            dataKey={getId}
            data={{
                items: results,
                isLoading,
                hasMore: hasNext ?? false,
                onLoadMore: loadNext,
            }}
            value={value}
            renderLabel={renderLabel}
            renderItem={renderItem}
            filterable={{
                placeholder: 'Search Monitoring Points',
                filterText: filter.nameSearch ?? '',
                onChange: (nameSearch) =>
                    setFilter((current) => ({ ...current, nameSearch })),
            }}
            onChange={onChange}
        />
    );
}
